import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { CalendarCheck } from "lucide-react";
import axios, { API } from "@/lib/apiClient";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { toast } from "sonner";

export const Booking = () => {
  const { auditId } = useParams();
  const [slots, setSlots] = useState([]);
  const [selected, setSelected] = useState(null);
  const [name, setName] = useState("");
  const [confirmed, setConfirmed] = useState(false);

  useEffect(() => {
    axios.get(`${API}/bookings/slots`).then((res) => setSlots(res.data.slots.slice(0, 20)));
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    if (!selected) return;
    try {
      await axios.post(`${API}/bookings`, { audit_id: auditId, name, slot: selected });
      setConfirmed(true);
      toast.success("Sovereign Strategy Call booked.");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Could not book that slot.");
    }
  };

  if (confirmed) {
    return (
      <div className="flex min-h-[70vh] flex-col items-center justify-center gap-4 px-6 text-center" data-testid="booking-confirmed">
        <CalendarCheck className="h-10 w-10 text-truth-green" />
        <h1 className="font-heading text-2xl font-bold text-white">Your Sovereign Strategy Call is booked</h1>
        <p className="text-sm text-slate-500">{new Date(selected).toLocaleString()}</p>
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-2xl px-6 py-16" data-testid="booking-page">
      <h1 className="mb-2 font-heading text-2xl font-bold text-white">Book Your Sovereign Strategy Call</h1>
      <p className="mb-8 text-sm text-slate-500">Pick a slot for your 1:1 consultation with the BrandSignal strategy team.</p>

      <div className="mb-6 grid grid-cols-2 gap-2 sm:grid-cols-3" data-testid="booking-slots-grid">
        {slots.map((s) => (
          <button
            key={s}
            onClick={() => setSelected(s)}
            className={`rounded-md border px-3 py-2 text-xs transition-colors ${selected === s ? "border-sovereign bg-sovereign/10 text-white" : "border-surface-border bg-surface-card text-slate-400 hover:border-sovereign/40"}`}
            data-testid={`booking-slot-${s}`}
          >
            {new Date(s).toLocaleString(undefined, { weekday: "short", month: "short", day: "numeric", hour: "numeric" })}
          </button>
        ))}
      </div>

      <form onSubmit={submit} className="space-y-3">
        <Input required placeholder="Your name" value={name} onChange={(e) => setName(e.target.value)} className="border-surface-border bg-obsidian text-white" data-testid="booking-name-input" />
        <Button type="submit" disabled={!selected} className="w-full bg-sovereign text-white hover:bg-sovereign/90" data-testid="booking-confirm-btn">
          Confirm Booking
        </Button>
      </form>
    </div>
  );
};
